
export interface NoveltyInputLanguageDetectRequest {
    /**
     * 用户输入
     */
    input: string;
}

export type NoveltyInputLanguageDetectResponse = string;

/**
 * 输入语言检测 API
 */
export interface NoveltyInputLanguageDetectApi {
    /**
     * 检测输入语言
     */
    detect(data: NoveltyInputLanguageDetectRequest): Promise<NoveltyInputLanguageDetectResponse>;
}

export const NoveltyInputLanguageDetectApi = Symbol.for('NoveltyInputLanguageDetectApi');
